'use strict';

angular.module('internal.trainings')
    .directive('internalTrainingActions', [function () {
        return {
            restrict: 'E',
            templateUrl: paths.app + 'trainings/components/training-actions/training-actions.html',
            replace: true,
            controller: 'InternalActions'
        };
    }])
;